import { EmployeeActionHandlers, EmployeeBase } from '@dap/memberadmin/types';

export function hasAnyDefinedActions<T extends EmployeeBase>(actions: EmployeeActionHandlers<T>) {
  return Object.keys(actions).some(
    (key) => !!typeof actions[key as keyof EmployeeActionHandlers<T>]
  );
}

export function isCurrentUser(
  employee: Pick<EmployeeBase, 'userId'>,
  currentUserId: string | undefined
): boolean {
  return Boolean(currentUserId) && employee.userId === currentUserId;
}

export function excludeCurrentUser<T extends Pick<EmployeeBase, 'userId'>>(
  employees: T[],
  currentUserId: string | undefined
): T[] {
  return employees.filter((employee) => !isCurrentUser(employee, currentUserId));
}

export function omitRemoveActionsForCurrentUser<T extends EmployeeBase>(
  actions: EmployeeActionHandlers<T>,
  employee: T,
  currentUserId: string | undefined
): EmployeeActionHandlers<T> {
  if (!isCurrentUser(employee, currentUserId)) {
    return actions;
  }

  const rest: EmployeeActionHandlers<T> = { ...actions };
  delete rest.onRemove;
  delete rest.onRemoveFromLocation;
  return rest;
}
